import { PointOfInterest } from './../itineray.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-itinerary-day-poi-form',
  templateUrl: './itinerary-day-poi-form.component.html',
  styleUrls: ['./itinerary-day-poi-form.component.css']
})
export class ItineraryDayPoiFormComponent implements OnInit {

  @Input()
  poi: PointOfInterest;

  @Input()
  poiId: string;

  @Input()
  disabled: boolean;

  constructor() { }

  ngOnInit() {
  }

}
